import { render, staticRenderFns } from "./create-training-program.component.vue?vue&type=template&id=179ad041&scoped=true&"
import script from "./create-training-program.component.vue?vue&type=script&lang=js&"
export * from "./create-training-program.component.vue?vue&type=script&lang=js&"
import style0 from "./create-training-program.component.vue?vue&type=style&index=0&id=179ad041&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179ad041",
  null
  
)

export default component.exports